var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrdersNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 214",
    d: "M8.61524 2.32881L1.61524 9.04598C1.2222 9.42315 1 9.94431 1 10.489V18C1 19.1046 1.89543 20 3 20H7.1219C7.46879 20 7.75 19.7188 7.75 19.3719V15.3409C7.75 14.0983 8.75736 13.0909 10 13.0909C11.2426 13.0909 12.25 14.0983 12.25 15.3409V19.3719C12.25 19.7188 12.5312 20 12.8781 20H17C18.1046 20 19 19.1046 19 18V10.489C19 9.94431 18.7778 9.42315 18.3848 9.04598L11.3848 2.32881C10.6109 1.58623 9.38909 1.58623 8.61524 2.32881Z",
    stroke: "white",
    strokeOpacity: 0.56,
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersNew);
export default __webpack_public_path__ + "static/media/ordersNew.d0a1088af76156985f1d575c93cc60d3.svg";
export { ForwardRef as ReactComponent };